import { HttpErrorResponse, HttpStatusCode } from "@angular/common/http";

export function isUnauthorizedHttpError(err: unknown): boolean {
	return err instanceof HttpErrorResponse && err.status === HttpStatusCode.Unauthorized;
}
